<template>
  <v-card
    outlined
    class="px-6"
  >
    <label class="subtitle-1 d-block pb-3 pt-2 mt-4 grey--text">{{ componentLabel }}</label>
    <v-text-field
      v-bind="attributes"
      v-on="listeners"
    />
    <div class="pb-6 d-flex flex-row-reverse">
      <v-btn
        x-small
        color="primary"
        :loading="loading"
        text
        :disabled="!baseString"
        @click="generate"
      >Generate</v-btn>
    </div>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  props: {
    baseString: {
      type: String,
      required: false
    },
    componentLabel: {
      type: String,
      default: 'URL Slug'
    },
    isPath: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    attributes () {
      return {
        outlined: true,
        flat: true,
        label: 'URL Slug',
        readonly: this.loading,
        loading: this.loading,
        ...this.$attrs
      }
    },
    listeners () {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
    ...mapActions({
      generateArticleSlug: 'article/generateArticleSlug'
    }),
    async generate () {
      try {
        this.loading = true
        if (this.baseString) {
          const { data } = await this.generateArticleSlug({ title: this.baseString })

          if (this.isPath) {
            let tempSlug = '/' + data.slug
            data.slug = tempSlug
          }
          this.$emit('input', data.slug)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
